import http from '@/requests/http'

class AgentApiKey {
  static findAll (params) {
    return http.post('agent/api-key', params)
  }
  static getKey () {
    return http.post('agent/api-key/get-key')
  }
  static store (params) {
    return http.post('agent/api-key/store', params)
  }
  static view (params) {
    return http.post('agent/api-key/view', params)
  }
  static update (params) {
    return http.post('agent/api-key/update', params)
  }
  static destroy (params) {
    return http.post('agent/api-key/destroy', params)
  }
}

export default AgentApiKey
